import { render, staticRenderFns } from "./feature_upsell.vue?vue&type=template&id=597e8dbc&scoped=true&"
import script from "./feature_upsell.vue?vue&type=script&lang=js&"
export * from "./feature_upsell.vue?vue&type=script&lang=js&"
import style0 from "./feature_upsell.vue?vue&type=style&index=0&id=597e8dbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597e8dbc",
  null
  
)

export default component.exports